import React, { Fragment } from "react";

import Hero from "../components/Hero";
import Content from "../components/Content";
import { returnTextByOrg } from "../utils/textHelpers";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

const Home = ({
  hideCustomers,
  hideEmployees,
  setHideEmployees,
  setHideCustomers,
}) => {
  const hostname = window.location.hostname;
  const splithostname = hostname.split(".");
  let subdomain = splithostname[0];
  let organization,
    connection = "";
  if (
    splithostname.length > 3 ||
    (splithostname.length > 1 && splithostname[1].includes("localhost"))
  ) {
    organization = connection = subdomain;
  }

  const { user, isAuthenticated, loginWithRedirect, logout } = useAuth0();

  return (
    <>
      <style>
        {`
        .continue-title {
            ${returnTextByOrg(organization, {
              southcentralpower: "color:#d87e3f;",
              austinutilities: "color:#84963e;",
              oec: "color:#3a9776;",
              nisc: "color:#89343c;",
            })}
          }

          .continue-button {
            width: 35%;
            font-size: 20px;
            padding: 8px;
          }
      
      `}
      </style>
      <Fragment>
        <Hero />
        <hr />

        <Content />
        <hr />
        {organization && hideCustomers && hideEmployees && !isAuthenticated && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <h1 className="text-center continue-title">Continue as...</h1>

            <button
              className="continue-button"
              onClick={() => setHideCustomers(false)}
            >
              End Consumer
            </button>
            <button
              className="continue-button"
              onClick={() => setHideEmployees(false)}
            >
              Employee
            </button>
          </div>
        )}
      </Fragment>
    </>
  );
};

export default Home;
